import { redirectToErrorPage, logAndRedirectToErrorPage, logError } from 'components/ErrorComponent';
import { history } from "../routerHistory";
import { AuthenticationError } from "../common/AuthenticationError";
import CryptoJS from 'crypto-js';
import { getCsrfToken } from './cookieService';

const controller = new AbortController();
const { signal } = controller;

export const get = async (url) => {
    try {
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'GET',
            signal
        });
        if (response.status === 200) {
            if (response.url.includes('/account/userinfo') || response.url.includes('/account/userproducts')){
                const result = await response.json();
                return VerifyIntegrity(result);
            }else{
                return response.json();// Ensure you're not calling logAndRedirectToErrorPage here
            }
        }
        if (response.status === 403) {
            controller.abort();
            window.location.href = window.location.origin + "/Account/Login?returnUrl=" + encodeURIComponent(window.location.pathname + window.location.search);
            throw new AuthenticationError("User not authenticated!");
        }
        if (response.status && (response.status === 400 || response.status >= 500)) {
            logAndRedirectToErrorPage(response.json(), history);
        }
    } catch (e) {
        if (e instanceof AuthenticationError)
            throw e;
        redirectToErrorPage(history);
    }
}
export const post = async (url, body) => {
    try {
        const csrfToken = await getCsrfToken();
        if (!csrfToken) {
            throw new Error('CSRF token missing');
        }
        const response = await fetch(url, {
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            signal,
            credentials: 'include',
            method: 'POST'
        });
        if (response.status === 200) {
            return await response.json(); // Ensure you're not calling logAndRedirectToErrorPage here
        }
        if (response.status === 403) {
            controller.abort();
            window.location.href = window.location.origin + "/Account/Login?returnUrl=" + encodeURIComponent(window.location.pathname + window.location.search);
            throw new AuthenticationError("User not authenticated!");
        }
        if (response.status && (response.status === 400 || response.status >= 500)) {
            logAndRedirectToErrorPage(response.json(), history);
        }
        return response.json();
    } catch (e) {
        if (e instanceof AuthenticationError)
            throw e;
        redirectToErrorPage(history);
    }
}

function VerifyIntegrity(response){
    try {
        const receivedData = response.data;
        const receivedHash = response.integrityHash;
    
        // Recompute the hash of the received data
        const computedHash = CryptoJS.SHA256(receivedData).toString(CryptoJS.enc.Base64);
    
        // Check if the computed hash matches the received hash
        if (computedHash !== receivedHash) {
          throw new Error('Data integrity check failed!');
        }
        // If integrity is valid, parse the data
        return JSON.parse(receivedData);
      } catch (err) {
        logError(err);
      }
}
